const name = str => `<span class="font-weight-bold font-italic">${str}</span>`
const i = str => `<span class="font-italic">${str}</span>`

export { name, i }
